// frontend/src/pages/HowToPage.jsx
import React from 'react';
import AdminLayout from './AdminLayout';

const tutorials = [
  {
    id: 1,
    title: 'Creating a New User and Verifying Login',
    description:
      'Learn how to create a new user account in SaccoTeck, assign a role, link it to a member record, and verify that the account can log in successfully.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/hope-sacco-42375.firebasestorage.app/o/SaccoTeck_Create_User.mp4?alt=media&token=6e8e9df5-692a-4ef2-b12e-66362c37c378',
    duration: '1:03',
  },
  {
    id: 2,
    title: 'Editing a Member Profile',
    description:
      'Learn how a member can log in and update their personal information, SACCO details, next of kin, and beneficiaries through the member portal.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/hope-sacco-42375.firebasestorage.app/o/SaccoTeck_Edit_Profile_Final.mp4?alt=media&token=3515e1a3-f54d-4e46-970b-fe9ad462681f',
    duration: '0:54',
  },
  {
    id: 3,
    title: 'Resetting Your Password',
    description:
      'Learn how to reset your password using the Forgot Password link, and what happens when an unregistered email is used.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/hope-sacco-42375.firebasestorage.app/o/SaccoTeck_Reset_Password_Final.mp4?alt=media&token=4f46616b-0c20-4418-a55c-eccb3e5244e4',
    duration: '0:58',
  },
];

const HowToPage = () => {
  return (
    <AdminLayout activePage="how-to" pageTitle="How To">
      <header className="top-bar">
        <h1>How To</h1>
      </header>

      <div style={{ padding: '24px 0' }}>
        <p style={{ color: '#555', marginBottom: 32, fontSize: 15 }}>
          Step-by-step video guides for using the SaccoTeck system.
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(480px, 1fr))',
          gap: 32,
        }}>
          {tutorials.map((t) => (
            <div key={t.id} style={{
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
              overflow: 'hidden',
              border: '1px solid #e8e8f0',
            }}>
              {/* Video player */}
              <video
                controls
                style={{ width: '100%', display: 'block', background: '#000' }}
              >
                <source src={t.videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              {/* Card body */}
              <div style={{ padding: '20px 24px 24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                  <span style={{
                    background: '#f0f0ff', color: '#4a4aff',
                    borderRadius: 6, padding: '2px 10px', fontSize: 12, fontWeight: 600,
                  }}>
                    🎬 {t.duration}
                  </span>
                </div>
                <h3 style={{ margin: '0 0 8px', fontSize: 16, color: '#1a1a2e' }}>{t.title}</h3>
                <p style={{ margin: 0, fontSize: 13, color: '#666', lineHeight: 1.6 }}>{t.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default HowToPage;
